import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Tooltip } from 'seagull';
import { LinkLiner24 } from 'seagull/icons';
import { getAccountingDetails } from '~/integrations/Accounting/accounting.utils';
import { formatDuration } from '~/models/time';
import { Accounting } from '~/types/api.model';
import { formatShortMonthUSDate } from '~/utils';
import styles from './TimeActivityTooltip.module.scss';
const TimeActivityTooltip = (param)=>{
    let { timeActivity, grouped = false } = param;
    const accountingName = getAccountingDetails(Accounting.QBO).fullName;
    return /*#__PURE__*/ _jsx(Tooltip, {
        testId: "time-activity-".concat(timeActivity.id, "-tooltip"),
        title: /*#__PURE__*/ _jsx("div", {
            style: {
                minWidth: 'fit-content'
            },
            "data-testid": "time-activity-tooltip-text",
            children: grouped ? "This line item is connected to a billable time activities in ".concat(accountingName, ". For further\n                        information please view the invoice in your ").concat(accountingName, " account.") : /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    "This line item is connected to a billable time activity in ",
                    accountingName,
                    ".",
                    /*#__PURE__*/ _jsx("br", {}),
                    "Customer: ",
                    /*#__PURE__*/ _jsx("b", {
                        children: timeActivity.customer.name
                    }),
                    /*#__PURE__*/ _jsx("br", {}),
                    "Date: ",
                    /*#__PURE__*/ _jsx("b", {
                        children: formatShortMonthUSDate(new Date(timeActivity.date))
                    }),
                    /*#__PURE__*/ _jsx("br", {}),
                    "Mapped service name: ",
                    /*#__PURE__*/ _jsx("b", {
                        children: timeActivity.item.name
                    }),
                    /*#__PURE__*/ _jsx("br", {}),
                    "Original duration:",
                    ' ',
                    /*#__PURE__*/ _jsx("b", {
                        children: formatDuration({
                            hours: timeActivity.hours,
                            minutes: timeActivity.minutes
                        })
                    }),
                    /*#__PURE__*/ _jsx("br", {}),
                    "Original note: ",
                    /*#__PURE__*/ _jsx("b", {
                        children: timeActivity.note
                    })
                ]
            })
        }),
        children: /*#__PURE__*/ _jsx("div", {
            className: styles.icon,
            "data-testid": "time-activity-".concat(timeActivity.id, "-icon"),
            children: /*#__PURE__*/ _jsx(LinkLiner24, {
                size: 18
            })
        })
    });
};
export default TimeActivityTooltip;
